import React, { Component } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as appActions } from "../../modules/appModule"

import NavBar from "../../components/layout/DashboardNavbar"
import ConfirmAccountForm from "../../forms/ConfirmAccountForm"
import AnonPage, { Content } from "../../components/AnonPage"
import Footer from "../../components/Footer"
import { COLOR } from "../../modules/constants"

class ConfirmAccount extends Component {

  componentDidMount() {
    // clear any confirm/resend error left over from a previous attempt this session
    this.props.app.confirmAccountError(null)
    this.props.app.resendCodeResult(null)
  }

  render() {
    const { app, confirmError, portrait, resendResult, urlSource } = this.props
    const href = `https://www.numerable.io/?utm_source=${urlSource}&utm_medium=numapp&utm_campaign=confirmaccount`

    return (
      <React.Fragment>
        <NavBar unauthorized title="Confirm Registration" backLink portrait={portrait} />

        <AnonPage>
          <Content scroll>
            <div className="form-page">
              <div className="form-cell">
                <div className="form-wrapper">
                  <a href={href}><p className={"numerable-logo"}></p></a>
                  <p className="anon-title" >Confirm Registration</p>
                  <ConfirmAccountForm onSubmit={form => app.confirmAccount(form)} />
                  <p className="error-message">
                    {confirmError}
                  </p>
                  <div className="alternative-link">
                    <Link onClick={(event) => {
                      app.resendCode()
                      event.preventDefault()
                      return false
                    }} to="" style={{ color: COLOR.BRAND.STD }} >re-send confirmation code</Link>
                  </div>
                  <p className="error-message">
                    {resendResult}
                  </p>
                </div>
              </div>
            </div>
          </Content>
        </AnonPage>

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    confirmError: app.confirmError,
    resendResult: app.resendResult,
    urlSource: common.urlSource,
    portrait: user.portrait,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAccount)

